
import { IItemCache } from '../../models/IItemCacheObserver';
import { connectToItemCache } from './connectToItemCache';
import { IItemColumn } from '../../models/schema/IItemColumn';
import { itemSetColumnsControl, IItemColumnListProps } from '../../controls/itemSetColumnsControl';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { fileTypeIconColumn } from '../columns/fileTypeIcon/fileTypeIconColumn';
import { displayNameColumn } from '../columns/displayName/displayNameColumn';
import { fieldsColumn } from '../columns/fields/fieldsColumn';
import { IComponentDecorator, IDecoratedProps } from '../../utilities/components/Decorators';

/**
 * @public
 * @deprecated Use `itemSetColumnsControl` instead.
 */
export interface IColumnSelector {
  (itemCache: IItemCache, itemSetKey?: string, columns?: IColumn[]): IItemColumn[];
}

/**
 * @public
 */
export interface IWithColumnSelectorProps {
  columnSelector?: IColumnSelector;
  itemKey: string | undefined;
}

/**
 * @public
 */
export type IDecorateWithColumnSelectorProps<TProps> =
  IDecoratedProps<TProps, IItemColumnListProps, IItemColumnListProps & IWithColumnSelectorProps>;

/**
 * @internal
 */
export function withColumnSelector(): IComponentDecorator<IItemColumnListProps, IItemColumnListProps & IWithColumnSelectorProps> {
    return connectToItemCache(mapColumnSelectorToProps);
}

const DEFAULT_COLUMNS: IItemColumn[] = [
  fileTypeIconColumn,
  displayNameColumn,
  fieldsColumn
];

function mapColumnSelectorToProps(
  itemCache: IItemCache,
  props: IItemColumnListProps & IWithColumnSelectorProps
): IItemColumnListProps {
  const {
    columns: defaultColumns
  } = props;

  const controlHandler = props.columnSelector ?
    createColumnSelectorControlHandler(props.columnSelector) :
    itemCache.demandItemFacet(itemSetColumnsControl, props.itemKey);

  const {
    columns = DEFAULT_COLUMNS,
    onColumnResize,
    layoutMode,
    skipViewportMeasures,
    columnReorderOptions
  } = itemSetColumnsControl.evaluate(controlHandler)(itemCache, {
    itemSetKey: props.itemKey,
    columns: defaultColumns
  });

  return {
    columns: columns.filter((column: IColumn) => column.key !== fieldsColumn.key), // TODO Memoize this.
    onColumnResize: onColumnResize,
    layoutMode: layoutMode,
    skipViewportMeasures: skipViewportMeasures,
    columnReorderOptions: columnReorderOptions
  };
}

function createColumnSelectorControlHandler(columnSelector: IColumnSelector): typeof itemSetColumnsControl.type {
  return (itemCache: IItemCache, props: typeof itemSetColumnsControl.inputType): typeof itemSetColumnsControl.returnType => {
    return {
      columns: columnSelector(itemCache, props.itemSetKey, props.columns)
    };
  };
}
